"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
function useValidation(_ref) {
  let {
    id,
    disabled,
    error,
    customValidationError,
    onInvalid
  } = _ref;
  const ref = (0, _react.useRef)(null);
  const [validationState, setValidationState] = (0, _react.useState)(null);
  const [isValid, setIsValid] = (0, _react.useState)(disabled || !customValidationError);
  const [errorElement, setErrorElement] = (0, _react.useState)(customValidationError || error);
  const determineRef = () => {
    const newRef = ref.current ? ref.current.getInputDOMNode ?
    // TextInput wraps InputElement from react-input-mask
    ref.current.getInputDOMNode() : ref.current : null;
    return newRef;
  };
  const onInvalidCallback = (0, _react.useCallback)(evt => {
    if (evt.preventDefault) {
      evt.preventDefault();
    }

    // when called directly, evt will be the ref.current value
    const validState = evt.currentTarget ? evt.currentTarget.validity : evt.validity;
    setValidationState(validState);
    if (onInvalid) {
      onInvalid(validState);
    }
  }, [onInvalid]);
  (0, _react.useEffect)(() => {
    const refCurrent = determineRef();
    if (refCurrent) {
      ref.current = refCurrent;
      refCurrent.addEventListener('invalid', onInvalidCallback);
    }
    return () => {
      if (refCurrent) {
        refCurrent.removeEventListener('invalid', onInvalidCallback);
      }
    };
  }, [onInvalidCallback]);
  (0, _react.useEffect)(() => {
    var _ref$current;
    const newIsValid = !disabled && customValidationError ? false : validationState ? validationState.valid : true;
    setIsValid(newIsValid);

    // update the actual element's validation state to ensure it wouldn't get submitted in a form if invalid
    if (ref !== null && ref !== void 0 && (_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.setCustomValidity) {
      ref.current.setCustomValidity(newIsValid ? '' : 'Invalid');
    }
  }, [disabled, customValidationError, validationState]);
  (0, _react.useEffect)(() => {
    setErrorElement(customValidationError || error);
  }, [customValidationError, error]);
  return {
    ref,
    errorId: "".concat(id, "-error"),
    isValid,
    errorElement,
    showInvalid: !isValid && Boolean(errorElement),
    validationState,
    setValidationState
  };
}
var _default = exports.default = useValidation;